import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import Select from "react-select";
import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import { toastError, toastSuccess } from "../../../common/Toast";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  DATA_EXPORT,
  ERROR_MESSAGE,
} from "../../../common/Constant";
import { Calendar } from "../../../common/imagePath";
import ReactDatetime from "react-datetime";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
// import jsPDF from "jspdf";
import "jspdf-autotable";
// import moment from "moment";

//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { Stack } from "react-bootstrap";
import { handleSaveColumnOrder } from "../../../common/common";

const currentDate = new Date();
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const month = monthNames[currentDate.getMonth()]; // add 1 to get month value from 1 to 12
const hours = currentDate.getUTCHours();
const minutes = currentDate.getUTCMinutes();

const AccountsReceivableAgingDetail = (props) => {
  const token = localStorage.getItem("Token");
  const loginuserid = localStorage.getItem("ID");
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [totalbalance, setTotalBalance] = useState(0);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(6);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [agingPeriod, setAgingPeriod] = useState(30);
  const [numberPeriod, setNumberPeriod] = useState(4);
  const [mindayspastdue, setMindayspastdue] = useState(0);
  const [columnOrder, setColumnOrder] = useState([]);
  const [columnVisibility, setColumnVisibility] = useState({});

  console.log(selectedDate , "selectedDate")

  //table state
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const barcodeRefs = useRef([]);
  let index = 0;
  const [data, setData] = useState([]);

  //Function to generate barcode
  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      console.log("barcodeRefs", barcodeRefs);
      var g = document.getElementsByTagName(barcodeRef);
      const barcodeValue = paramObject.id;
      console.log("barcodeValue", barcodeValue);
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 10,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  const handleDropdownChange = (event) => {
    // const selectedValue = event.target.value;
    setSelectReport(event?.value);
    console.log(event.target.value);
  };

  //Function for lookup receipt
  const paramObject = useParams();
  const apicall = () => {
    console.log(agingPeriod, numberPeriod, mindayspastdue, "parametersvvvvvv");

    axios
      .get(
        `${config.reportsBaseUrl}/reports/receivableagingdetail?startdate=${startdate}&enddate=${enddate}&daysperagingperiod=${agingPeriod}&numberofperiods=${numberPeriod}&mindayspastdue=${mindayspastdue}&loginId=${loginuserid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          const FilterData = res.data.ResponseData?.list?.map((el) => ({
            ...el,
            OpenBalance: Number(el?.OpenBalance),
            Amount: Number(el?.Amount),
          }));
          setResponseData(FilterData);
          setData(FilterData);
          // setDataResponse(res.data.ResponseData.Periods);

          console.log("11", responseData);
          setColumnOrder(res.data.ResponseData?.ColumnOrder?.length  > 0 ? res.data.ResponseData?.ColumnOrder.split(",") : ['mrt-row-select', ...columns.map((c) => c.accessorKey)]);
  
          // const keysToSetFalse = res.data.ResponseData?.ColumnsHide.length || "" ;
          const keysToSetFalse = res.data.ResponseData?.ColumnsHide.length > 0 ? res.data.ResponseData?.ColumnsHide : ['mrt-row-select', ...columns.map((c) => c.accessorKey)];
          console.log(keysToSetFalse , "keysToSetFalse")
          // Create default object with all values set to true
          const obj = columns.reduce((acc, item) => {
            acc[item.accessorKey] = true;
            return acc;
          }, {});
  
          // Comma-separated string of keys to set to false
  
          // Convert the string to an array and set the corresponding keys in the object to false
          keysToSetFalse.split(",").forEach((key) => {
            if (obj.hasOwnProperty(key)) {
              obj[key] = false;
            }
          });

          console.log(obj , "checkobj")
  
          setColumnVisibility(obj);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (
      (agingPeriod === undefined || agingPeriod === "") &&
      (numberPeriod === undefined || numberPeriod === "")
    ) {
      toastError("Days per aging period or Number of periods can't be empty");
      return;
    } else if (agingPeriod === undefined || agingPeriod === "") {
      toastError("Please enter a number between 1 to 500");
      return;
    } else if (numberPeriod === undefined || numberPeriod === "") {
      toastError("Please enter a number between 1 to 50");
      return;
    } else {
      apicall();
    }
  }, [startdate, enddate, agingPeriod, numberPeriod, mindayspastdue]);

  useEffect(() => {
    generateBarcodes();
    console.log("barcodeRefs", barcodeRefs);
    // setLoading(true);

    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        setData(res.data.ResponseData);

        // setLoading(false);
        return res;
      });
  }, [startdate, enddate]);

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Amount);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  const calculateTotalbalance = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.OpenBalance);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);
    setTotalBalance(sum);
  };

  useEffect(() => {
    calculateTotalSum();
    calculateTotalbalance();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };

  const columns = useMemo(() => [
    {
      header: "Date",
      accessorKey: "Date",
      size: 110,
    },
    {
      header: "Transaction Type",
      accessorKey: "TransactionType",
    },
    {
      header: "Num",
      accessorKey: "Num",
      size: 110,
    },
    {
      header: "Customer",
      accessorKey: "Customer",
    },
    {
      header: "Due Date",
      accessorKey: "DueDate",
      size: 110,
    },
    {
      header: "Amount",
      accessorKey: "Amount",
      size: 120,
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {Number(row.original.Amount ? row.original.Amount : 0).toFixed(2)}
          </div>
        );
      },
      AggregatedCell: ({ cell, table }) => (
        <>
          Oldest by{" "}
          {table.getColumn(cell.row.groupingColumnId ?? "").columnDef.header}:{" "}
          <Box
            sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
          >
            {" " +
              cell.getValue()?.toLocaleString?.("en-US", {
                style: "currency",
                currency: "USD",
                // minimumFractionDigits: 0,
                // maximumFractionDigits: 0,
              })}
          </Box>
        </>
      ),
      Footer: () => (
        <>
          <div style={{ textAlign: "end" }}>
            <Stack>
              Total:
              <Box color="warning.main">{totalSum.toFixed(2)}</Box>
            </Stack>
          </div>
        </>
      ),
    },
    {
      header: "Open Balance",
      accessorKey: "OpenBalance",
      size: 120,
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {Number(
              row.original.OpenBalance ? row.original.OpenBalance : 0
            ).toFixed(2)}
          </div>
        );
      },
      AggregatedCell: ({ cell, table }) => (
        <>
          Oldest by{" "}
          {table.getColumn(cell.row.groupingColumnId ?? "").columnDef.header}:{" "}
          <Box
            sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
          >
            {" " +
              cell.getValue()?.toLocaleString?.("en-US", {
                style: "currency",
                currency: "USD",
                // minimumFractionDigits: 0,
                // maximumFractionDigits: 0,
              })}
          </Box>
        </>
      ),
      Footer: () => (
        <>
          <div style={{ textAlign: "end" }}>
            <Stack>
              Total:
              <Box color="warning.main">{totalbalance.toFixed(2)}</Box>
            </Stack>
          </div>
        </>
      ),
    },
    {
      header: "Create Date",
      accessorKey: "CreateDate",
    },
    {
      header: "Created By",
      accessorKey: "CreatedBy",
      size: 120,
    },
    {
      header: "Last Modified",
      accessorKey: "LastModified",
    },
    {
      header: "Last Modified By",
      accessorKey: "LastModifiedBy",
      size: 120,
    },
    {
      header: "Phone",
      accessorKey: "Phone",
      size: 120,
    },
    {
      header: "Email",
      accessorKey: "Email",
    },
    {
      header: "FullName",
      accessorKey: "FullName",
    },
    {
      header: "Billing Address",
      accessorKey: "BillingAddress",
    },
    {
      header: "Shipping Address",
      accessorKey: "ShippingAddress",
    },
    {
      header: "Company Name",
      accessorKey: "CompanyName",
    },
    {
      header: "Ship Date",
      accessorKey: "ShipDate",
    },
    {
      header: "Ship Via",
      accessorKey: "ShipVia",
    },
    {
      header: "Tracking",
      accessorKey: "Tracking",
    },
    {
      header: "Terms",
      accessorKey: "Terms",
    },
    {
      header: "Client/ Vendor Message",
      accessorKey: "ClientVendorMessage",
    },
    {
      header: "Past Due",
      accessorKey: "DaysPastDue",
    },
    {
      header: "Delivery Address",
      accessorKey: "DeliveryAddress",
    },
    {
      header: "Memo Description",
      accessorKey: "MemoDescription",
    },
    {
      header: "Aging Period",
      accessorKey: "AgingPeriod",
    },
  ]);

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const totalFooterRow = {
    Period: "Total",
    Amount: totalSum,
    OpenBalance: totalbalance,
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3>Open Purchase Order List</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Accounts Receivable Aging Detail
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              {/* <div className="row"> */}
              {/* <div className="col-md-4 z-3"> */}
              <label className="col-form-label form-label p-lg-medium">
                Report period
              </label>
              <Select
                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                options={reportdropdown}
                // defaultValue={selectReport}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                hideSelectedOptions={true}
                isClearable={true}
                name="Reportperiod"
                id="Reportperiod"
                value={reportdropdown.find((e) => e.value === selectReport)}
                onChange={(event) => {
                  handleDropdownChange(event);
                }}
                className="custom-search-select"
              ></Select>
            </div>
            {(selectReport == 2 ||
              selectReport == 3 ||
              selectReport == 4 ||
              selectReport == 5 ||
              selectReport == 6 ||
              selectReport == 7 ||
              selectReport == 8 ||
              selectReport == 9 ||
              selectReport == 10 ||
              selectReport == 11 ||
              selectReport == 12 ||
              selectReport == 13 ||
              selectReport == 14 ||
              selectReport == 15 ||
              selectReport == 16 ||
              selectReport == 17 ||
              selectReport == 18 ||
              selectReport == 19 ||
              selectReport == 20 ||
              selectReport == 21 ||
              selectReport == 22 ||
              selectReport == 23 ||
              selectReport == 24 ||
              selectReport == 25 ||
              selectReport == 26 ||
              selectReport == 27 ||
              selectReport == 28 ||
              selectReport == 29 ||
              selectReport == 30 ||
              selectReport == 31) && (
              <div className="col-sm-6">
                <div className="row">
                  <ReportDate
                    callback={callback}
                    selectReport={selectReport}
                    showhidecomponent={
                      selectReport == 2 ||
                      selectReport == 3 ||
                      selectReport == 4 ||
                      selectReport == 5 ||
                      selectReport == 6 ||
                      selectReport == 7 ||
                      selectReport == 8 ||
                      selectReport == 9 ||
                      selectReport == 10 ||
                      selectReport == 11 ||
                      selectReport == 12 ||
                      selectReport == 13 ||
                      selectReport == 14 ||
                      selectReport == 15 ||
                      selectReport == 16 ||
                      selectReport == 17 ||
                      selectReport == 18 ||
                      selectReport == 19 ||
                      selectReport == 20 ||
                      selectReport == 21 ||
                      selectReport == 22 ||
                      selectReport == 23 ||
                      selectReport == 24 ||
                      selectReport == 25 ||
                      selectReport == 26 ||
                      selectReport == 27 ||
                      selectReport == 28 ||
                      selectReport == 29 ||
                      selectReport == 30 ||
                      selectReport == 31
                        ? true
                        : false
                    }
                  />
                </div>
              </div>
            )}
            <div className="col-sm-3 ">
              <label className="col-form-label form-label">
                Days per aging period
              </label>
              <input
                className="form-control"
                name="agingperiod"
                id="agingperiod"
                value={agingPeriod}
                onChange={(e) => {
                  setAgingPeriod(e.target.value);
                }}
              ></input>
            </div>
            <div className="col-sm-3 ">
              <label className="col-form-label form-label">
                Number of periods
              </label>
              <input
                className="form-control"
                name="numberperiod"
                id="numberperiod"
                value={numberPeriod}
                onChange={(e) => {
                  setNumberPeriod(e.target.value);
                }}
              ></input>
            </div>
            <div className="col-sm-3 ">
              <label className="col-form-label form-label">
                Min. Days Past Due
              </label>
              <input
                className="form-control"
                name="numberperiod"
                id="numberperiod"
                onChange={(e) => {
                  setMindayspastdue(e.target.value);
                }}
              ></input>
            </div>
            <div
              className="cursor-pointer col-md-3 d-flex justify-content-end mt-5"
              onClick={() =>
                handleSaveColumnOrder(
                  loginuserid,
                  "AccountPayableSummaryReport",
                  columnOrder,
                  token,
                  columnVisibility
                )
              }
              title="Lock Your Sequence"
            >
              <i class="fa fa-lock columnsLock fs-4"></i>
            </div>
            {/* <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary pull-right"
                style={{ marginLeft: "auto" }}
                onClick={apicall}
              >
                Generate Report
              </button>
            </div> */}
          </div>

          {/* Receipt */}

          <div className="card mt-3" id="print">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center" id="header">
                  <h6 className="p">SonarPos</h6>
                  <h6 className="fw-bold p-regular">
                    {" "}
                    Accounts Receivable Aging Detail
                  </h6>
                  <div className="row mb-2">
                    {/* <h6> Date: {new Date().toLocaleDateString()}</h6> */}
                    <p>
                      Date:{" "}
                      {startdate === "" && enddate === ""
                        ? "All Data"
                        : startdate + " - " + enddate}
                    </p>
                  </div>
                </div>
              </div>
              <hr />

              <div>
                <CommonMatrialReactTable
                  MainHeading="Sonar POS"
                  ReportHeading="Accounts Receivable Aging Detail"
                  columns={columns}
                  data={responseData}
                  startdate={startdate}
                  enddate={enddate}
                  columnGrouping={["AgingPeriod"]}
                  // columnsVisibility={{
                  //   CreateDate: false,
                  //   CreatedBy: false,
                  //   LastModified: false,
                  //   LastModifiedBy: false,
                  //   Phone: false,
                  //   Email: false,
                  //   FullName: false,
                  //   BillingAddress: false,
                  //   ShippingAddress: false,
                  //   CompanyName: false,
                  //   ShipDate: false,
                  //   ShipVia: false,
                  //   Tracking: false,
                  //   Terms: false,
                  //   ClientVendorMessage: false,
                  //   DaysPastDue: false,
                  //   DeliveryAddress: false,
                  //   MemoDescription: false,
                  // }}
                  setColumnOrder={setColumnOrder}
                  setColumnVisibility = {setColumnVisibility}
                  state={{
                    columnOrder,
                    columnVisibility,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountsReceivableAgingDetail;
